//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionEventEntityContent",
  components: {
    PhotoSign: () => import("@/components/common/PhotoSign"),
    Scroller: () => import('@/components/common/Scroller/index'),
    PlaceCard: () => import('@/components/common/PlaceCard'),
    HorizontalEntityCard: () => import('@/components/common/HorizontalEntityCard'),
    SocialVideoFrameComponent: () => import('@/components/common/SocialVideoFrameComponent'),
    AudioPlayer: () => import('@/components/common/AudioPlayer/index'),
    ScheduleCalendar: () => import("@/components/common/ScheduleCalendar/index"),
    ContextAdditions: () => import("@/components/common/ContextAdditions"),
    Brochure: () => import('@/components/common/Brochure/index'),
    EntityContent: () => import('@/components/common/EntityContent'),
    Section: () => import('@/components/common/Section/index'),
  },
  computed: {
    ...mapGetters({
      title: "event/title",
      agency: "event/agency",
      hasTickets: "event/hasTickets",
      bookingTerms: "event/bookingTerms",
      cancellationTerms: "event/cancellationTerms",
      audios: "event/audios",
      rutube: "event/rutube",
      youtube: "event/youtube",
      vkontakte: "event/vkontakte",
      description: "event/description",
      additions: "event/additions",
      place: "event/place",
      mediaSource: "event/mediaSource",
    }),
    showPlace() {
      return this?.place && this?.place?.status === 'active'
    }
  }
};
